import React, { PureComponent } from 'react'
import { ReactComponent as Icon } from './assets/cerebro.svg'
import SvgIcon from '@material-ui/core/SvgIcon'

export default class Cerebro extends PureComponent {
  render() {
    return <SvgIcon component={Icon} viewBox='0 0 228 254' />
  }
}
